<template>
    <li
        :class="{ active }"
        class="select-item"
    >
        <button
            class="select-item__cta"
            @click="$emit('click')"
            role="option"
            :aria-selected="active"
            tabindex="0"
        >
            <span v-if="this.langOptions" class="select-text" v-text="$ml.get('DisplayText')" />
            <span v-if="!this.langOptions" class="select-text">{{ this.canTranslate ? $ml.get(displayText) : displayText }}</span>
            <small v-if="this.item.grossAmount">{{ `(R$ ` + this.item.grossAmount + `)` }}</small>
            <CieloRadio :value="active" class="select-radio" />
        </button>
    </li>
</template>

<script>
    import CieloRadio from './CieloRadio';
    import { MLBuilder } from 'vue-multilanguage';
    import { Options } from '@/config/lang/genericOptions.js';

    export default {
        components: {
            CieloRadio
        },

        props: {
            active: {
                type: Boolean
            },
            displayText: {
                type: [String, Number],
                default: null
            },
            langOptions: {
                type: Options,
                default: null
            },
            item: {
                type: Object,
                default: null
            },
			canTranslate: {
				type: Boolean,
				default: false
			}
        },

        computed: {
            mlDisplayText() {
                if(!this.langOptions)
                    return;

                const builder = new MLBuilder(this.langOptions.langParameterName);

                this.langOptions.tokens.forEach((token) => {
                    builder.with(token.key, token.value);
                });

                return builder;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .select-item {
        &:not(:last-of-type) {
            border-bottom: 1.5px solid #B8C1CC;
        }

        &.active {
            .select-item__cta {
                color: $cielo-blue !important;
            }
        }

        &__cta {
            position: relative;
            background-color: transparent;
            border: none;
            padding: 16px 0;
            font-size: 16px;
            line-height: 24px;
            color: #2f363e;
            width: 100%;
            text-align: left;
            transition: all .3s ease-in-out;

            &:hover,
            &:focus {
                background-color: #F2F4F8;
            }

            small {
                margin-left: 8px;
            }
        }
    }
</style>
